import { autobind } from "core-decorators";
import { Inject } from "typescript-ioc";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { LangPopupSwitcher } from "Footer/Scripts/LangPopupSwitcher";

export class JoinUs extends UiComponent {
    public get key(): string {
        return "JoinUs";
    }

    private readonly SEL_POPUP_LANG_SWITCHER: string = ".ui-popup-lang-switcher";

    private readonly LEAVING_ALREADY_SEL: string = "#ui-leaving-already-dialog";
    private readonly LEAVING_ALREADY_CLASSNAME: string = "ui-leaving-already";
    private readonly CONFIRM_LEAVE_SEL: string = ".js-confirm-dialog";
    private readonly HIDE_LEAVING_ALREADY_DIALOG_SEL: string = ".ui-hide-leaving-dialog";
    private readonly LEAVING_ALREADY_TRIGGER_SEL: string =
        ".ui-join-us-support a, #simplified-oriflame-logo";

    private _lastRedirectUrl: string;
    private _kendoWindow: kendo.ui.Window | undefined;

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    public init(): void {
        this.initLeavingAlreadyDialog();
        this.initLangPopupSwitcher();
        this.bindEvents();
    }

    private initLeavingAlreadyDialog(): void {
        const dialog = this.findElement(this.LEAVING_ALREADY_SEL);
        this._kendoWindow = kendo.createWindow(dialog, {
            open: this._ensureWindowStyles,
        });
    }

    private initLangPopupSwitcher(): void {
        if (this.findElement(this.SEL_POPUP_LANG_SWITCHER)) {
            this.createComponent(LangPopupSwitcher, this.SEL_POPUP_LANG_SWITCHER);
        }
    }

    private bindEvents(): void {
        this.bindDelegatedClick(this.HIDE_LEAVING_ALREADY_DIALOG_SEL, this._hideDialog);
        this.bindDelegatedClick(this.CONFIRM_LEAVE_SEL, this._confirmDialog);
        this.bindDelegatedClick(this.LEAVING_ALREADY_TRIGGER_SEL, this._showLeavingAlready);
    }

    @autobind
    _ensureWindowStyles(event: kendo.ui.WindowEvent): void {
        event.sender.wrapper.addClass(this.LEAVING_ALREADY_CLASSNAME);
    }

    @autobind
    _hideDialog(): void {
        this._kendoWindow?.close();
    }

    @autobind
    _confirmDialog(): void {
        window.location.href = this._lastRedirectUrl;
    }

    @autobind
    _showLeavingAlready(event: Event): void {
        const target = event.target as HTMLElement;
        this._lastRedirectUrl = target?.getAttribute("href") ?? "/";
        this._kendoWindow?.open();
        event.preventDefault();
    }
}
